import React, { FC } from "react";
import { FolderWrapper } from "../FolderWrapper";
import { SECTION_IDS } from "../constants";
import { ContactUsForm } from "./ContactUsForm";
import { AssistanceBlock } from "./AssistanceBlock";

export const ContactUsSection: FC = () => (
  <FolderWrapper
    title="Зв'язок"
    titleClassName="text-green-base"
    className="flex flex-col items-center justify-center bg-white-base py-8.25 overflow-x-clip lg:py-18 lg:flex-row"
    id={SECTION_IDS.CONTACT_US}
  >
    <ContactUsForm />
    <AssistanceBlock />
  </FolderWrapper>
);
